import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';

import type { RouteContext } from '@atlassian/jira-router';
import RapidBoardCardColoursSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-colours';
import RapidBoardCardLayoutSettings from '@atlassian/jira-spa-apps-classic-board-settings-card-layout';
import RapidBoardColumnsSettings from '@atlassian/jira-spa-apps-classic-board-settings-columns';
import RapidBoardEstimationSettings from '@atlassian/jira-spa-apps-classic-board-settings-estimation';
import RapidBoardGeneralSettings from '@atlassian/jira-spa-apps-classic-board-settings-general';
import RapidBoardQuickFiltersSettings from '@atlassian/jira-spa-apps-classic-board-settings-quick-filters';
import RapidBoardSwimlanesSettings from '@atlassian/jira-spa-apps-classic-board-settings-swimlanes';
import RapidBoardTimelinesSettings from '@atlassian/jira-spa-apps-classic-board-settings-timeline';
import RapidBoardWorkingDaysSettings from '@atlassian/jira-spa-apps-classic-board-settings-working-days';
import type RapidBoardType from '@atlassian/jira-spa-apps-rapid-board';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page';

export const BoardConfigSwitcher = (props: RouteContext) => {
	const { route, query, match } = props;
	const basePageId = (route && route.name) || 'rapid-board';
	const chartParam = query.chart ? `-${query.chart}` : '';
	const boardId = query.rapidView ?? match.params.boardId;
	const pageId = `${basePageId}-${boardId}${chartParam}`;

	switch (query.config) {
		case 'filter':
			return <RapidBoardGeneralSettings />;
		case 'columns':
			return <RapidBoardColumnsSettings />;
		case 'swimlanes':
			return <RapidBoardSwimlanesSettings />;
		case 'quickFilters':
			return <RapidBoardQuickFiltersSettings pageId={pageId} />;
		case 'cardColors':
			return <RapidBoardCardColoursSettings pageId={pageId} />;
		case 'cardLayout':
			return <RapidBoardCardLayoutSettings />;
		case 'estimation':
			return <RapidBoardEstimationSettings />;
		case 'time':
			return <RapidBoardWorkingDaysSettings />;
		case 'timelineConfig':
			return <RapidBoardTimelinesSettings />;
		default:
			return <LazyPage Page={LazyRapidBoard} pageId={pageId} shouldShowSpinner={false} />;
	}
};

const LazyRapidBoard = lazyForPaint<typeof RapidBoardType>(
	() =>
		import(
			/* webpackChunkName: "async-rapid-board", jiraSpaEntry: "async-rapid-board" */ '@atlassian/jira-spa-apps-rapid-board'
		),
);
